import React from "react";

import handBookStyles from "pages/HandBook/HandBook.module.scss";
import { HANDBOOK_SHOW_MORE_LIMIT, SEGMENTS_APPLY_EDITINGS_LOADER_TEXT } from "pages/HandBook/const";
import { useCheckAll } from "pages/HandBook/hooks/useCheckAll";
import { HANDBOOK_TEMPLATE_LVL } from "pages/HandBook/model/slice";
import { IHandBookSegment } from "pages/HandBook/model/types";
import TemplateBlurLoader from "pages/HandBook/ui/TemplateBlurLoader/TemplateBlurLoader";

import HandBooksTemplatesRow from "../../HandBooksTemplatesRow";
import icon from "./../../../../assets/handbook.svg";
import { useHandbookTemplateSegments } from "./useHandbookTemplateSegments";
import TableReusableHead, { TableReusableHeaderCell } from "shared/ui/dataDisplay/TableReusable/TableReusableHead";
import Checkbox from "shared/ui/inputs/Checkbox/Checkbox";
import BackNavigationBar from "shared/ui/layout/BackNavigationBar/BackNavigationBar";
import ListWrapper from "shared/ui/layout/ListWrapper/ListWrapper";
import RowGrid from "shared/ui/layout/RowGrid/RowGrid";

const colPercents = [100];
const formColPercents = [3, 97];
const headerColPercents = [3, 97];

const HandBooksTemplateSegments = () => {
  const {
    displaySegments,
    isLoading,
    isLoadingMore,
    isLoadingApplyEditings,
    total,
    filter,
    onChangeFilter,
    onRowClick,
    onPagination,
    columns,
    onBack,
    currentTemplate,
    currentSegment,
    isEditing,
  } = useHandbookTemplateSegments();

  const { allChecked, handleToggleAllChecked } = useCheckAll({
    lvl: HANDBOOK_TEMPLATE_LVL.SEGMENTS,
    displayItems: displaySegments,
  });

  return (
    <>
      <ListWrapper
        data={displaySegments as IHandBookSegment[]}
        dataMapper={(item: IHandBookSegment) => (
          <HandBooksTemplatesRow
            item={item}
            key={item.id}
            colPercents={colPercents}
            formColPercents={formColPercents}
            columns={columns}
            nameFieldPlaceholder={`Введите название атрибута`}
            onRowClick={() => onRowClick(item.id)}
          />
        )}
        beforeHeader={
          <BackNavigationBar
            onBack={onBack}
            title={currentTemplate?.name || "Шаблоны"}
            slashTitle={currentSegment?.name || ""}
            isBold
            className={handBookStyles.backNavigationBar}
          />
        }
        header={
          <TableReusableHead isSticky isNoDefaultGridCols>
            <RowGrid percents={headerColPercents}>
              {isEditing && (
                <TableReusableHeaderCell isCentered>
                  <Checkbox onCheck={handleToggleAllChecked} checked={allChecked} noMargin />
                </TableReusableHeaderCell>
              )}
              {columns.map((el: any) => (
                <TableReusableHeaderCell
                  key={el.header.title}
                  isCentered={el.isCentered}
                  filterType={el.header.filterType ? el.header.filterType : el.header.filterName ? "text" : undefined}
                  filterField={el.header.filterName}
                  onChangeFilter={onChangeFilter}
                  filterTitle={el.header.title}
                  isLast={el.isLast}
                  filterOptions={el.header.filterOptions}
                  isRighted={el.isRighted}
                  isDebouncedFilterApply
                >
                  {el.header.title}
                </TableReusableHeaderCell>
              ))}
            </RowGrid>
          </TableReusableHead>
        }
        placeholderProps={{
          img: icon,
          text: "Нет сведений",
          fullHeight: false,
        }}
        total={total}
        isLoading={isLoading}
        isLoadingMore={isLoadingMore}
        filter={filter}
        onPagination={onPagination}
        paginationLimit={HANDBOOK_SHOW_MORE_LIMIT}
      />
      {isLoadingApplyEditings && <TemplateBlurLoader text={SEGMENTS_APPLY_EDITINGS_LOADER_TEXT} />}
    </>
  );
};

export default HandBooksTemplateSegments;
